import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center mt-8" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Online access ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_HeroFestivalSlogan = _resolveComponent("HeroFestivalSlogan")
  const _component_Hero = _resolveComponent("Hero")

  return (_openBlock(), _createBlock(_component_Hero, null, {
    default: _withCtx(({ isMobile }) => [
      _createVNode(_component_HeroFestivalSlogan, {
        texts: ['Movies.', 'Online.', 'Filmin.'],
        color: "filmin-green",
        isMobile: isMobile,
        isOnline: true
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_Button, {
              color: "filmin-green",
              as: "a",
              href: "https://www.filmin.es/festival/atlantida-film-fest-2022",
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ])
        ]),
        _: 2
      }, 1032, ["texts", "isMobile"])
    ]),
    _: 1
  }))
}